// projects_cards.jsx - Versão Final
import React, { useCallback, useRef } from 'react';
import { Wrapper, CardContainer, ImageContainer, Image, Title, Info, InnerContainer, StatusCAR } from "./styles";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DefaultForestImage from '../../assets/default-image2.png';
import { setSelectedProject } from '../../store/modules/projects/actions.js';

export const Card = ({ filteredProjects }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // Ref para controle de cliques
  const clickTimeoutRef = useRef(null);
  const isProcessingRef = useRef(false);
  // Função handleClick
  const handleClick = useCallback((project, event) => {
    // Previne múltiplos cliques
    if (isProcessingRef.current) {
      return;
    }

    if (!project) {
      console.warn('⚠️ [Card] Projeto é null ou undefined');
      return;
    }

    if (clickTimeoutRef.current) {
      return;
    }

    isProcessingRef.current = true;

    try {

      dispatch(setSelectedProject(project));

      navigate(`/intern_project/${project.id}`, { state: { project } });

    } catch (error) {
      console.error('❌ [Card] Erro durante navegação:', error);
    } finally {
      clickTimeoutRef.current = setTimeout(() => {
        isProcessingRef.current = false;
        clickTimeoutRef.current = null;
      }, 500); // Aumentei para 500ms para garantir
    }
  }, [dispatch, navigate]);

  // Verificação se filteredProjects existe
  if (!filteredProjects || filteredProjects.length === 0) {
    return (
      <Wrapper>
        <div>Nenhum projeto encontrado.</div>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {filteredProjects.map((project, index) => {
        const areaCount = project.guardian_areas ? project.guardian_areas.length : 0;

        return (
          <CardContainer
            key={project.id || index}
            onClick={(e) => {
              handleClick(project, e);
            }}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClick(project, e);
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            <ImageContainer>
              <Image
                src={project.project_image_url || DefaultForestImage}
                alt={project.title === "default" ? 'Sem Título' : project.title}
              />
            </ImageContainer>
            <InnerContainer>
              <Title
                score={project.score || '0'}
                title={project.title === "default" ? 'Sem Título' : project.title}
              >
                {project.title === "default" ? 'Sem Título' : project.title}
              </Title>
              <Info>
                Proprietário:
                <StatusCAR status={project.owner_details?.full_name ? 'active' : 'inactive'}>
                  {project.owner_details?.full_name || 'Não informado'}
                </StatusCAR>
              </Info>
              <Info>
                Áreas:
                <StatusCAR status={areaCount > 0 ? 'active' : 'inactive'}>
                  {areaCount} {areaCount === 1 ? 'área' : 'áreas'}
                </StatusCAR>
              </Info>
              <Info>
                Status:
                <StatusCAR status={project.status_display ? 'active' : 'inactive'}>
                  {project.status_display || 'Não informado'}
                </StatusCAR>
              </Info>
            </InnerContainer>
          </CardContainer>
        );
      })}
    </Wrapper>
  );
};

export default React.memo(Card);